import { Component, OnInit } from "@angular/core";
import { ApiIntegration } from "../../_services/api.integration";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "../../_models/user";
import { Globals } from "../../_models/globals";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import * as _ from "lodash";
import { AlertService } from "../../_services/alert.service";
import { OrderHeader } from "../../_models/orderHeader";
import { OrderLine } from "../../_models/orderLine";
//import {LocalStorageService,SessionStorageService,LocalStorage,SessionStorage,} from "angular-web-storage";
import { Index } from "src/app/_models";

@Component({
  selector: "app-create-return-manually",
  templateUrl: "./create-return-manually.component.html",
  styleUrls: ["./create-return-manually.component.scss"],
})
export class CreateReturnManuallyComponent implements OnInit {
  tabClicked = "selectedProducts";
  order: OrderHeader = {};
  searchOrderNumber: string;
  orderLines: OrderLine[] = [];

  quantityError: string;
  selectReasonError: string;
  reasonsList: any = [];
  returnOrderlines: any = [];
  orderLine: any = {};
  searchError: string = "";
  shipmentCarrierData: any;
  returnPickupCarrierlist : any = [];
  costEstimate : any;
  length: string;
  lengthError: string;
  width: string;
  widthError: string;
  height: string;
  heightError: string;
  weight: string;
  weightError: string;
  shippingCost: any;
  productQuantity :number;
  values: number;
  invalidProductNoEntryError: string[];
  costEstimation : any[];
  quantity : any;
  orderError = {};
  meta : any;
 /*  dimensions = {
  weight: "",
  height: "",
  length : "",
  breadth : ""
  }; */


  constructor(
    private alertService: AlertService,
    private http: HttpClient,
    private g: Globals,
    private api: ApiIntegration,
    private route: ActivatedRoute,
    private router: Router,
    public user: User
  ) {
  this.searchOrderNumber = this.route.snapshot.params['orderNumber'];
              if(this.searchOrderNumber){
                 this.getReturnOrder();
               }
  };





    onKey(event: any,orderLine:OrderLine,index:number) {
      this.values = Number(event.target.value);
      console.log(this.values + 1);
      console.log(this.productQuantity);
      if(orderLine["previousQuantity"] == 1 || (this.values > 0 && this.values <= orderLine?.previousQuantity)){
       this.invalidProductNoEntryError[index] = "";
      }else if(this.values <= 0){
           this.invalidProductNoEntryError[index] = "Inventory should be more than Zero"
      } else {
           this.invalidProductNoEntryError[index] = "Inventory cannot be more than ordered Quantity"
      }
    }



  reasonSettingsList() {
    this.api
      .getValues(
        "1",
        "ACCOUNT_OWNER",
        this.user.accountOwnerId || this.order.accountOwnerId,
        "REASON"
      )
      .subscribe(
        (data: any) => {
          this.reasonsList = data.tripleSetConfigDTOS;
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
  }

  getReturnOrder() {
    this.returnPickupCarrierlist=[];
    this.invalidProductNoEntryError = [];
    if (this.searchOrderNumber) {
      this.searchError = "";
      this.g.loaderDisplay = "display";
      this.api
        .getOrdersEligibleForReturn(this.searchOrderNumber)
        .subscribe(
          (resp: any) => {
            console.log("this.searchOrderNumber");
            if(resp["code"] == 200){
            this.selectReasonError ="";
            this.g.loaderDisplay = "";
            this.order = resp;
            /* this.orderError =resp.metadata; */
              this.orderLines = _.cloneDeep(this.order.lines);
              let index = 0;
              this.orderLines.forEach((d) => {
                d["previousQuantity"] = d.quantity;
                this.invalidProductNoEntryError[index++]="";
              });
              this.width="",
              this.height= "",
              this.length = "",
              this.weight ="",
              this.returnOrderlines=[];
              this.reasonSettingsList();
              }else{
               this.g.loaderDisplay = "";
              this.alertService.error("Error",resp["message"]);
              }
          },
          (err) => {
            this.g.loaderDisplay = "";
            this.returnOrderlines=[];
            this.alertService.error("Error", err);
          }
        );
    }
  }




  tabChange(tab) {
    this.tabClicked = tab;
  }

  removeProduct(rp) {
    let index = this.orderLines.indexOf(rp);
    this.orderLines.splice(index, 1);
  }

  clearFields() {
    for (let ol of this.orderLines) {
      let i = this.orderLines.indexOf(ol);
      this.orderLines.splice(i, 1);
    }
  }

  ngOnInit() {}

  moveToShipping() {
    this.selectReasonError = "";

    if (!this.orderLines.length) {
      this.quantityError = "Atleast one product is need to return order";
    }
    if (!this.order.returnReason) {
      this.selectReasonError = "Please select reason";
    }
    if (this.selectReasonError || this.invalidProductNoEntryError.length <= 0) {
      return;
    }
    this.tabClicked = "shippingOptions";
  }

  checkError() {
    this.selectReasonError = "";
    if (!this.order.returnReason) {
      this.selectReasonError = "Please select reason";
    }
  }


  Submit() {
  let dimensions : any ={
                      breadth: this.width,
                      height: this.height,
                      length: this.length,
                      weight: this.weight,
                      };
                      for(let ol of this.orderLines){
                        this.orderLine.orderLineId= ol.orderLineId;

                        this.orderLine.returnQuantity = ol.quantity;
                        this.returnOrderlines.push(_.cloneDeep(this.orderLine));
                      }

    let details : any = {
              shipMethod: "PARCEL",
              shippingOption: this.shippingCost.carrierCode,
              shippingType:this.shippingCost.serviceType || this.shippingCost.deliveryMode,
              shipmentPrice: this.shippingCost.totalAmount,
              destination: this.order.pickupAreaPinCode,
              origin: this.order.deliveryAreaPinCode,
              totalBoxes: 1
    }

    this.selectReasonError = "";

    if (!this.orderLines.length) {
      this.quantityError = "Atleast one product is need to return order";
    }
    if (!this.order.returnReason) {
      this.selectReasonError = "Please select reason";
    }
    if (this.selectReasonError || this.invalidProductNoEntryError.length <= 0) {
      return;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/orders/"+this.order.orderNumber +"/return-orders",
        {
/*        accountOwnerContactId: this.order.accountOwnerCustomerId,
          additionalInfo: this.order.additionalInfo,
          lines: this.orderLines,
          awbNumber: this.order.awbNumber,
          connectionName: this.order.connectionName,
          deliveryInstructions: this.order.deliveryInstructions,
          externalOrderId: this.order.sourceOrderId || "",
          externalShipmentId: "string",
          //"inProcessDate": "2020-10-01T02:22:36.391Z",
          originalOrderDate: this.order.createdDate,
          originalOrderHeaderId: this.order.orderHeaderId,
          pickupAddressId: 0,
          productConfig: this.order.productConfig,
          providerStatus: this.order.providerStatus,
          receivedDate: "2020-10-01T02:22:36.392Z",
          referenceOrderId: "string",
          returnOrderDate: "string",
          returnOrderHeaderId: 0,
          shipmentPrice: 0,
          shippingMethod: this.order.shippingMethod,
          shippingOption: this.order.shippingOption,
          sourceOrderDate: this.order.sourceOrderDate,
          sourceType: "string",
          trackingNumber: this.order.trackingNumber,
          warehouseId: this.order.warehouseId,
          "orderNumber": this.order.orderNumber,
          "accountOwnerId": this.order.accountOwnerId,
          "destPincode": this.order.pickupAreaPinCode,
          "originPincode": this.order.deliveryAreaPinCode,
          "orderStatus": "SUBMITTED",
          "orderType": this.order.orderType,
          "returnReason": this.order.returnReason,*/
          "organizationId": 1,
          "accountOwnerId": this.order.accountOwnerId,
          "returnReason" : this.order.returnReason,
          "orderLines": this.returnOrderlines,
          "shippingDetails": details,
          "dimensions":dimensions,
        },
        { headers: header1 }
      )
      .subscribe(
        (data : any) => {
          this.g.loaderDisplay = "";

               if (data["code"] == 200) {
               this.returnOrderlines=[];
            this.alertService.success("Order", "Return Successfully");
            if ( this.user.role == "ACCOUNT_OWNER" || this.user.role ==  'AO_SELLER') {
              this.router.navigate(["/admin/returns"]);
            } else {

              this.router.navigate(["/admin/adminReturns"]);
            }
          } else {
          this.g.loaderDisplay = "";
          this.returnOrderlines=[];
            this.alertService.error("Error", data["message"]);
          }
        },
        (err) => {
        this.returnOrderlines=[];
          this.g.loaderDisplay = "";
          this.alertService.error("Error", err);
        }
      );
  }

  /* shippingCarrier() {
         if(this.returnPickupCarrierlist && this.returnPickupCarrierlist.length > 0){
             return;
  }
    this.g.loaderDisplay = "display";
    this.api.getShippingCarrier(this.searchOrderNumber.trim(), *//* this.weight,this.length,this.height *//* ).subscribe(
      (resp: any) => {
        this.g.loaderDisplay = "";
        if (resp?.data?.length != 0) {
          this.shipmentCarrierData = resp.data;
          this.carrier();
        }
      },
      (err) => {
        this.g.loaderDisplay = "";
        this.alertService.error("Error", err);
      }
    );
  }
 */


  submitCostEstimation(){

     if(this.costEstimation && this.costEstimation.length > 0){
                  return;
       }


     this.lengthError = "";
     this.widthError = "";
     this.heightError = "";
     this.weightError = "";
          if (!this.length) {
              this.lengthError = 'Please enter length';
          }
          if (!this.width) {
              this.widthError = 'Please enter width';
          }
          if (!this.height) {
              this.heightError = 'Please enter height';
          }
          if (!this.weight) {
              this.weightError = 'Please enter weight';
          }
        if ( this.lengthError != '' || this.widthError != '' || this.heightError != '' || this.weightError != '') {
                return false;
        }
      this.g.loaderDisplay = "display";
      var header1 = new HttpHeaders();
      this.g.loaderDisplay = "display";
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.post(environment.apiUrl + 'api/costEstimationForShiftAggregator', {
        "breadth": this.width,
        "destPincode": this.order.pickupAreaPinCode,
        "originPincode": this.order.deliveryAreaPinCode,
        "height": this.height,
        "length": this.length,
        "orderType": "PICK",
        "organizationId": this.user.organizationId,
        "paymentMethod": "Reverse",
        "weight": this.weight,
        },
        {headers: header1}).subscribe(data => {
          this.g.loaderDisplay = "";
          if (data['code'] == 200) {
            this.costEstimate = data;
            this.costEstimation = this.costEstimate.costEstimateList;
            this.carrier();
            this.alertService.success('Cost Estimation', 'Submitted successfully');
          } else {
            this.alertService.error('Error', data['message']);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }


carrier(){
  this.costEstimation?.forEach((shipMent : any) => {
    shipMent?.costEstimates?.forEach((cost : any) => {

       this.returnPickupCarrierlist.push(cost);

      return this.returnPickupCarrierlist;
    })
    console.log(this.returnPickupCarrierlist);
  })
}



selectCost(o){
this.shippingCost = o;
}

typeLength(){
    this.lengthError = "";
    if (!this.length) {
        this.lengthError = 'Please enter length';
    }
  }

  typeWidth(){
  this.widthError = "";
   if (!this.width) {
       this.widthError = 'Please enter width';
   }
  }

  typeHeight(){
  this.heightError = "";
    if (!this.height) {
        this.heightError = 'Please enter height';
    }
  }

  typeWeight(){
    if (!this.weight) {
        this.weightError = 'Please enter weight';
    }
  }


   typeError(){
        this.selectReasonError='';
        if(this.order.returnReason==null || this.order.returnReason == undefined || this.order.returnReason=="" ){
        this.selectReasonError = "Please select the Reason";
        }}

}
